import { _ as _extends } from '../../extends-30811c5e.js';
import { _ as _defineProperty } from '../../defineProperty-6f298737.js';
import { _ as _objectWithoutProperties } from '../../objectWithoutProperties-dd908bcc.js';
import React__default from 'react';
import classNames from 'classnames';

var _excluded = ["highlightColor", "size", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/* eslint-disable @typescript-eslint/no-unused-vars */

var IconGift = function IconGift(_ref) {
  _ref.highlightColor;
    var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    newProps = _objectWithoutProperties(_ref, _excluded);
  var props = _objectSpread(_objectSpread({
    width: size,
    height: size
  }, newProps), {}, {
    className: classNames('sol-icon', className)
  });
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React__default.createElement("g", {
    id: "icon-gift"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M11.18 9.16545H4.83798C3.82295 9.16545 3 9.99023 3 11.0075V12.9527H11.18V9.16545Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M21.3543 12.9527V11.0075C21.3543 9.99023 20.5314 9.16545 19.5163 9.16545H13.1743V12.9527H21.3543Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M4.14715 15.3723V20.1579C4.14715 21.1752 4.97009 22 5.98513 22H11.18V15.3723H4.14715Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M13.1743 22H18.3692C19.3842 22 20.2072 21.1752 20.2072 20.1579V15.3723H13.1743V22Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12.1226 6.93998L9.98757 3.2348C9.03866 1.5884 6.66744 1.5884 5.71853 3.2348C4.76962 4.8812 5.95576 6.93998 7.85357 6.93998H12.1226Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12.177 6.93998L14.3121 3.2348C15.261 1.5884 17.6322 1.5884 18.5811 3.2348C19.53 4.8812 18.3439 6.93998 16.4461 6.93998H12.177Z",
    fill: "currentColor"
  }))));
};

export { IconGift };
